import React from 'react'
import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <footer className="border-t border-line py-6">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 text-sm text-muted">
        <p>&copy; {new Date().getFullYear()} MyWrenchLog</p>
        <div className="flex items-center gap-5">
          <Link to="/privacy" className="hover:text-ink hover:underline underline-offset-4">Privacy</Link>
          <a href="mailto:support@mywrenchlog.com" className="hover:text-ink hover:underline underline-offset-4">
            support@mywrenchlog.com
          </a>
        </div>
      </div>
    </footer>
  )
}
